import type { AuthPort, Credentials, SessionPort } from '../domain/auth'

const makeLoginUseCase = (auth: AuthPort, session: SessionPort) => async (credentials: Credentials) => {
	const result = await auth.login(credentials)

	if (result.success) session.set(result.session)

	return result
}

export { makeLoginUseCase }
